import { RootState } from '@core/store/states/root.state'
import { createSelector } from '@ngrx/store'
import { resolveMetricDetailSubHeader } from '@features/metric-detail/utils/metric-detail.utils'
import { selectCurrentSeasonAndCompetition } from '@features/seasons/state/selectors/seasons.selectors'
import { CallingContext } from '@features/seasons/models/seasons.models'

export const selectMetricDetailFeature = (state: RootState) => state.metricDetail

export const selectMetricDetailItems = createSelector(selectMetricDetailFeature, (state) => state.items)
export const selectMetricDetailLoader = createSelector(selectMetricDetailFeature, (state) => state.loading)

export const selectMetricDetailContext = createSelector(selectMetricDetailFeature, (state) => state.metricContext)

export const selectMetricDetailDisplayMode = createSelector(selectMetricDetailFeature, (state) => state.displayMode)

export const selectMetricDetailSubHeader = (callingContext: CallingContext) =>
  createSelector(
    selectMetricDetailDisplayMode,
    selectMetricDetailContext,
    selectCurrentSeasonAndCompetition(callingContext),
    (displayMode, metricContext, { competition }) =>
      resolveMetricDetailSubHeader(displayMode, { ...metricContext, competition })
  )
